import { memo } from 'react';
import { arrayOf, node, oneOfType, bool } from 'prop-types';

import { Section, Title } from '~/elements';

import styles from './TreatmentListDetails.scss';

const TreatmentListDetails = ({ isMultipleAppointment, children }) => (
  <Section className={styles.TreatmentListDetails} data-testid="TreatmentListDetails">
    <Title className={styles.TreatmentListDetailsTitle} data-testid="TreatmentListDetailsTitle">
      {isMultipleAppointment ? 'Treatments' : 'Treatment'}
    </Title>
    {children}
  </Section>
);

TreatmentListDetails.propTypes = {
  isMultipleAppointment: bool.isRequired,
  children: oneOfType([node, arrayOf(node)]).isRequired,
};

export const MemoizedTreatmentListDetails = memo(TreatmentListDetails);
